import React from "react";
import { motion } from "framer-motion";

// Subtle, calm reveal — fade + small upward translate. No flashy motion.
export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export const Kicker = ({ children, className = "" }) => (
  <span
    className={`font-mono text-[0.7rem] uppercase tracking-[0.28em] text-sage ${className}`}
  >
    {children}
  </span>
);
